module.exports = __webpack_public_path__ + "img/mzkh.11584e55.png";